/** @jsx jsx */
import { css, styled, jsx } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { media } from '@atlaskit/primitives/responsive';
import { componentWithFG } from '@atlassian/jira-feature-gate-component/src/index.tsx';
import { COMPACT_BREAKPOINT } from '../constants.tsx';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const DividerOld = styled.hr({
	border: 0,
	borderBottom: `1px solid ${token('color.border')}`,

	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	[`@media (max-width: ${COMPACT_BREAKPOINT - 1}px)`]: {
		marginBlock: token('space.075'),
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	[`@media (min-width: ${COMPACT_BREAKPOINT}px)`]: {
		marginBlock: token('space.100'),
	},
});

const dividerStyles = css({
	border: 0,
	borderBottom: `1px solid ${token('color.border')}`,

	[media.below.lg]: {
		marginBlock: token('space.075'),
	},
	[media.above.lg]: {
		marginBlock: token('space.100'),
	},
});

const DividerNew = () => <hr role="presentation" css={dividerStyles} />;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Divider = componentWithFG(
	'tnk-632-refactor-epic-panel-responsiveness',
	DividerOld,
	DividerNew,
);
